
export class IgApi {
  static cache = {};

  /**
   * Get profile
   * @param options {Object}
   * @param options.username {string} - username
   * @param options.subscribeSignedRequestBody {Function} - Function that returns signed request body
   * @param options.signal {AbortSignal} - Abort signal
   */
  static async getProfile(options) {
    const { username, subscribeSignedRequestBody, signal } = options;

    return this.requestToWorkerHub({
      endpoint: 'profile',
      body: {
        username,
      },
      subscribeSignedRequestBody,
      signal,
    });
  }

  /**
   * Get story
   * @param options {Object}
   * @param options.trimmedQuery {string} - trimmedQuery
   * @param options.subscribeSignedRequestBody {Function} - Function that returns signed request body
   * @param options.signal {AbortSignal} - Abort signal
   */
  static async getStory(options) {
    const { trimmedQuery, subscribeSignedRequestBody, signal } = options;

    return this.requestToWorkerHub({
      endpoint: 'story',
      body: {
        url: trimmedQuery,
      },
      subscribeSignedRequestBody,
      signal,
    });
  }

  /**
   * Get stories by username
   * @param options {Object}
   * @param options.userId {string} - userId
   * @param options.username {string} - userId
   * @param options.subscribeSignedRequestBody {Function} - Function that returns signed request body
   * @param options.signal {AbortSignal} - Abort signal
   */
  static async getStories(options) {
    const { userId, username, subscribeSignedRequestBody, signal } = options;

    return this.requestToWorkerHub({
      endpoint: 'stories',
      body: {
        userId,
        username,
      },
      subscribeSignedRequestBody,
      signal,
    });
  }

  /**
   * Get hightlights
   * @param options {Object}
   * @param options.profileId {string} - Profile id
   * @param options.subscribeSignedRequestBody {Function} - Function that returns signed request body
   * @param options.signal {AbortSignal} - Abort signal
   */
  static async getHighlights(options) {
    const { profileId, subscribeSignedRequestBody, signal } = options;

    return this.requestToWorkerHub({
      endpoint: 'highlights',
      body: {
        userId: profileId,
      },
      subscribeSignedRequestBody,
      signal,
    });
  }

  /**
   * Get stories by highlight id
   * @param options {Object}
   * @param options.highlightId {string} - highlightId
   * @param options.subscribeSignedRequestBody {Function} - Function that returns signed request body
   * @param [options.signal] {AbortSignal} - Abort signal
   */
  static async getHighlightStoriesById(options) {
    const { highlightId, subscribeSignedRequestBody, signal } = options;

    return this.requestToWorkerHub({
      endpoint: 'highlightStories',
      body: {
        highlightId,
      },
      subscribeSignedRequestBody,
      signal,
    });
  }

  /**
   * Request to worker hub
   * @param options {Object}
   * @param options.endpoint {'profile' | 'userInfo' | 'stories' | 'highlights' | 'story' | 'highlightStories' | 'usernameSuggestions' | 'posts' | 'reels' | (string & {})} - Endpoint
   * @param options.body {Record<string, any>} - Request body
   * @param options.subscribeSignedRequestBody {Function} - Function that returns signed request body
   * @param options.signal {AbortSignal} - Abort signal
   * @returns {AxiosResponse}
   */
  static async requestToWorkerHub(options) {
    const { endpoint, body, subscribeSignedRequestBody, signal } = options;    

    const requestUrl = `/api/v1/instagram/${endpoint}`;

    if (this.cache[requestUrl + ':' + JSON.stringify(body)]) {
      return this.cache[requestUrl + ':' + JSON.stringify(body)];
    }

    if (!subscribeSignedRequestBody) {
      console.warn('subscribeSignedRequestBody is not defined');

      const response = await axios.post(requestUrl, body, {
        signal,
      });

      if (response.data?.success !== false) {
        this.cache[requestUrl + ':' + JSON.stringify(body)] = response;
      }

      return response;
    }

    const response = await axios.post(
      requestUrl,
      {
        ...(await subscribeSignedRequestBody(body)),
      },
      { signal }
    );

    if (response.data?.success !== false) {
      this.cache[requestUrl + ':' + JSON.stringify(body)] = response;
    }

    return response;
  }
}
